import {createSelector} from "@reduxjs/toolkit";
import {selectPharmacistEmployees} from "./auth/authSlice";
import {selectSelectedPharmacy} from "./pharmacySlice";

export const selectEmployees = createSelector(selectPharmacistEmployees, selectSelectedPharmacy, (employees, pharmacy) => employees && employees.length && pharmacy? employees.filter(ele => ele.idPharmacy === pharmacy.idDocument) : []);
